import { IChildrenProp } from 'types/components/components.interface';
import './ContractPage.scss';

interface IContractPageProps extends IChildrenProp {}

const ContractPage = ({ children }: IContractPageProps) => {
  return <div className='contract-page-wrapper'>{children}</div>;
};

export default ContractPage;
